class SignInRedirectError extends Error {
  constructor(message) {
    super(message);
    this.name = 'SignInRedirectError';
  }
}

export default SignInRedirectError;
